export default {
  checklistTemplates: [],
  checklistTemplate: undefined,
};
